import * as React from 'react'
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface IVinInputState {
    value: string;
}

export interface IVinInputProps {
    id: string;
    label: string;
    value?: string;
    onChange?: any;
    validationLength: number;
    loadingServicesByVin: boolean
}

export class VinInput extends React.Component<IVinInputProps, IVinInputState>{
    constructor(props: IVinInputProps) {
        super(props);
        this.state = { value: this.props.value ? this.props.value : '' };

        this.handleChange = this.handleChange.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    public componentDidMount() {
        const vin = (new URLSearchParams(window.location.search)).get("vin");
        if (!!vin && !this.state.value) {
            this.setState({ value: vin });

            const url = new URL(window.location.toString());
            if (url.searchParams.has('vin')) {
                url.searchParams.delete('vin');
                window.history.replaceState({}, '', url.toString());
            }

            this.props.onChange instanceof Function && this.props.onChange(vin, true);
        }
    }

    handleChange(event: any): void {
        this.setState({ value: event.target.value });
        this.props.onChange instanceof Function && this.props.onChange(event.target.value, false);
    }

    isValid() {
        if (this.state.value != null && this.state.value.length == this.props.validationLength)
            return 'valid';

        return 'invalid';
    }

    render() {
        return (
            <div className="vin-input-container">
                <div>
                    <label className="vin-input-label">{this.props.label}</label>
                </div>
                <div>
                    <input className="vin-input-value" type="text" value={this.state.value} onChange={this.handleChange} maxLength={this.props.validationLength} />
                    {this.props.loadingServicesByVin ?
                        <span className="vin-input-info preloader"><FontAwesomeIcon icon={faCircleNotch} spin /></span>
                        :
                        <span className={`vin-input-info ${this.isValid()}`}>&#8203;</span>
                    }
                </div>
            </div>
        );
    }
}